import _ from 'lodash';
import { getState } from '~src/state';
import { getSelectedFormatId } from '~loader/loader-utils';
import getGraphQlClient from '~graphql/getGraphQlClient';
import { onErrorShowMessage } from '~src/errors';
import {
  GET_TEMPLATES_DEFAULT,
  GET_TEMPLATE_DEFAULT_BY_ID,
  GET_TEMPLATE_BY_ID,
} from '~graphql/queries/editorTemplates';
import { unmarshalGraphqlResponse } from '~graphql/utils';
import { getUser, isLoggedUserGlobalEditor } from '~src/user';
import { FEATURES, isFeatureEnabled } from '../../features';

let limit = 100;

export const fetchEditorTemplateById = async (id, isGlobal) => {
  try {
    const graphQlClient = await getGraphQlClient();

    const response = await graphQlClient.query({
      variables: {
        id,
      },
      query: isGlobal ? GET_TEMPLATE_DEFAULT_BY_ID : GET_TEMPLATE_BY_ID,
    });

    return unmarshalGraphqlResponse(
      response.data,
      isGlobal ? 'getEditorTemplatesDefault' : 'getEditorTemplates'
    );
  } catch (error) {
    onErrorShowMessage();
    console.error(error);
  }
};

export const fetchEditorTemplates = async (forceFetch = false) => {
  const projectType = getState('selected.tipo');
  const formatId = getSelectedFormatId();

  const allowNew = await isFeatureEnabled(FEATURES.CREATE_TEMPLATES, false);
  const allowNewCategory = await isFeatureEnabled(
    FEATURES.CREATE_TEMPLATES_CATEGORIES
  );

  const isGlobalEditor = await isLoggedUserGlobalEditor();

  const paramsDefault = {
    defaultProjectTypeId: projectType.objectId,
    defaultFormatId: formatId,
    formatId,
    projectTypeId: projectType.objectId,
    orgId: (await getUser())?.user?.org_pointer?.objectId,
    limit,
  };

  try {
    const graphQlClient = await getGraphQlClient();

    const response = await graphQlClient.query({
      fetchPolicy: forceFetch ? 'network-only' : 'cache-first',
      variables: paramsDefault,
      query: GET_TEMPLATES_DEFAULT,
    });

    let items = [];
    let categories = [];

    [
      'templateCustomTypeDefaultFormatDefault',
      'templateCustomTypeDefaultFormatCustom',
      'templateCustomTypeCustomFormatDefault',
      'templateCustomTypeCustomFormatCustom',
      'findEditorTemplatesDefault',
    ].forEach((attr) => {
      items = items.concat(
        response.data[attr]?.edges.map((edge) => {
          return edge.node;
        })
      );
    });

    [
      'editorTemplatesDefaultCategories',
      'editorTemplatesCategoriesOfDefaultProjectType',
      'editorTemplatesCategoriesOfCustomProjectType',
    ].forEach((attr) => {
      categories = categories.concat(
        response.data[attr]?.edges.map((edge) => {
          return edge.node;
        })
      );
    });

    items = items.map((item) => {
      const newItem = _.cloneDeep(item);

      if (newItem.isGlobal) {
        const sortedTemplatePages = _.sortBy(
          item.editor_templates_default_pages.edges,
          ['node.order']
        );
        newItem.editor_templates_default_pages.edges = sortedTemplatePages;
      } else {
        const sortedTemplatePages = _.sortBy(
          item.editor_templates_pages.edges,
          ['node.order']
        );
        newItem.editor_templates_pages.edges = sortedTemplatePages;
      }
      return newItem;
    });

    return {
      categories: {
        allowNew: isGlobalEditor || allowNewCategory || false,
        items: categories,
      },
      templates: {
        allowNew: isGlobalEditor || allowNew || false,
        items,
      },
    };
  } catch (error) {
    onErrorShowMessage();
    console.error(error);
  }
};
